import { render, staticRenderFns } from "./leave-case-apply.vue?vue&type=template&id=3489a782"
import script from "./leave-case-apply.vue?vue&type=script&lang=ts"
export * from "./leave-case-apply.vue?vue&type=script&lang=ts"
import style0 from "./leave-case-apply.vue?vue&type=style&index=0&id=3489a782&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports